"use client";

import { useEffect, useState } from "react";

import { normalizeRuntimePlan } from "@/lib/plans/planConfig";
import { supabase } from "@/lib/supabaseClient";

export function useCurrentUser() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    async function refresh() {
      if (!supabase) {
        if (!active) return;
        setUser(null);
        setLoading(false);
        return;
      }
      const { data: userData } = await supabase.auth.getUser();
      const authUser = userData?.user || null;
      if (!authUser) {
        if (!active) return;
        setUser(null);
        setLoading(false);
        return;
      }

      let runtimePlan = "free";
      let subscriptionStatus = null;
      try {
        const { data: sess } = await supabase.auth.getSession();
        const token = sess?.session?.access_token;
        if (token) {
          const response = await fetch("/api/billing/status", {
            headers: { Authorization: `Bearer ${token}` },
          });
          const payload = await response.json().catch(() => ({}));
          if (response.ok) {
            runtimePlan = String(payload?.plan || "free").toLowerCase();
            subscriptionStatus = typeof payload?.status === "string" ? payload.status : null;
          }
        }
      } catch {
        runtimePlan = "free";
      }

      if (!active) return;
      setUser({
        id: authUser.id,
        email: authUser.email || null,
        createdAt: authUser.created_at || null,
        plan: normalizeRuntimePlan(runtimePlan, true),
        runtimePlan,
        subscriptionStatus,
      });
      setLoading(false);
    }

    void refresh();
    const subscription = supabase?.auth.onAuthStateChange(() => {
      void refresh();
    });
    return () => {
      active = false;
      subscription?.data?.subscription?.unsubscribe?.();
    };
  }, []);

  return { user, loading };
}
